var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKontenFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 148,
    viewBox: "0 0 250 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1292_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 42.7175,
    y: -6.2666,
    width: 40,
    height: 174.09,
    transform: "rotate(-15 42.7175 -6.2666)",
    fill: "#E4F8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 232,
    cy: 15,
    r: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 146,
    r: 29.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 146,
    r: 39.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 146,
    r: 19.5,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1292_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 148,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontenFrame);
export default __webpack_public_path__ + "static/media/kontenFrame.d2e42920838f8180eeda03caed030f10.svg";
export { ForwardRef as ReactComponent };